<template>
    <router-view />
</template>

<script>
export default {
  
}
</script>




// WEBPACK FOOTER //
// resources/assets/js/components/office/postcode-fees/PostcodeFeesComponent.vue